import React from "react";
import { Locale } from "@linkfluence/models/locale";
import Tile from "@radarly/components/cards/card";
import Message from "@radarly/components/cards/limits/message";

interface IProps {
  title?: string;
  message: string;
  locale: Locale;
  height: number;
  subtitle: React.ReactNode;
}

const RadarlyCardsLimits = ({
  title = "",
  message,
  locale,
  height,
  subtitle,
}: IProps) => (
  <Tile title={title} height={height} subtitle={subtitle}>
    <Message message={message} locale={locale} />
  </Tile>
);

export default RadarlyCardsLimits;
